import React from "react";
import SidebarMenu from "./SidebarMenu";
import SidebarMenuFooter from "./SidebarMenuFooter";
import {DashboardSidebar} from "peggirkit";
import {Route} from "@/routing/Router";
import LocationSelector from "@widgets/layout/menu/LocationSelector/LocationSelector";

const Sidebar = (currentPage: Route) => (
    <DashboardSidebar
        width={320}
        header={<LocationSelector/>}
        sections={<SidebarMenu currentPage={currentPage}/>}
        footer={<SidebarMenuFooter/>}
    />
);

export default Sidebar;